<app-header></app-header>
<main class="main-content">
    <!------main-content------>
    <!-----------page_title--------------->
    <section class="page_title  pdt_80  pdb_40">
       <div class="container">
          <div class="row">
             <!---------row----------->
             <div class="col-lg-12 col-md-12 text-center">
                <!---------col----------->
                <div class="content_box">
                   <h1> COVID-19 Vaccination Passport</h1>
                   <ul class="bread_crumb text-center">
                      <li class="bread_crumb-item"><a href="#">Home</a></li>
                      <li class="bread_crumb-item active"> Vaccination Passport </li>
                   </ul>
                </div>
                <!---------col-end---------->
             </div>
             <!----------row-end---------->
          </div>
       </div>
    </section>
    <!-----------page_title-end-------------->
    
    

   <section class=" contact_page type_two pdt_50  pdb_50">
      <div class="container">

        <div class="contact_us_form">
            <h3>Fill Below form to apply Vaccination Passport</h3>
            <div class="form_box type_one">
               <form [formGroup]="passportForm" (ngSubmit)="onSubmit(passportForm.value)" autocomplete="off">
                  <div class="messages"></div>
                  <div class="controls">
                     <div class="row">
                        <div class="col-lg-6">
                           <div class="form-group">
                              <label for="exampleInputEmail1">Name</label>
                              <input type="text" class="percent_100 login_input_padding" name="name" placeholder="Name" formControlName="name"  
                              [ngClass]="{ 'is-invalid': submitted &amp;&amp; passportForm.controls.name.errors }"
                              [style.border-color]="submitted &amp;&amp; passportForm.controls.name.errors ?'#dc3545' : ''" />
                              
                             <div *ngIf="submitted &amp;&amp; passportForm.controls.name.errors" class="form-text text-danger">
                                <div *ngIf="passportForm.controls.name.errors.required">Name is required</div>
                                <div *ngIf="passportForm.controls.name.errors.maxlength">Name cannot be more than 45 characters</div> 
                                <div *ngIf="passportForm.controls.name.errors.pattern">Name must contain alphabets</div> 
                             </div>
                              <!-- <div class="help-block with-errors"></div> -->
                           </div>
                        </div>
                        <div class="col-lg-6">
                           <div class="form-group">
                              <label for="exampleInputEmail1">Email</label>
                              <input type="email" class="percent_100 login_input_padding" name="email" placeholder="Your Email Address" formControlName="email" 
                              [ngClass]="{ 'is-invalid': submitted &amp;&amp; passportForm.controls.email.errors }"
                              [style.border-color]="submitted &amp;&amp; passportForm.controls.email.errors ?'#dc3545' : ''" />
                              
                              <div *ngIf="submitted &amp;&amp; passportForm.controls.email.errors" class="form-text text-danger">
                                <div *ngIf="passportForm.controls.email.errors.required">Email is required</div>
                                <div *ngIf="passportForm.controls.email.errors.pattern">Please enter a valid email</div> 
                             </div>
                              <div class="help-block with-errors"></div>
                           </div>
                        </div>

                        <div class="col-lg-6">
                           <div class="form-group">
                              <label for="exampleInputEmail1">Phone</label>
                              <input type="text" class="percent_100 login_input_padding" name="phone" placeholder="Your Phone" formControlName="phone"
                              [ngClass]="{ 'is-invalid': submitted &amp;&amp; passportForm.controls.phone.errors }" maxlength="11"
                              [style.border-color]="submitted &amp;&amp; passportForm.controls.phone.errors ?'#dc3545' : ''" />
                              
                              <div *ngIf="submitted &amp;&amp; passportForm.controls.phone.errors" class="form-text text-danger">
                                <!-- <div *ngIf="passportForm.controls.phone.errors.required">Phone number is required</div>-->
                                <!-- <div *ngIf="passportForm.controls.phone.errors.pattern">Please enter a valid Phone number</div>   -->
                                 <div *ngIf="passportForm.controls.phone.errors.required">Phone Number is required</div>
                                 <div *ngIf="passportForm.controls.phone.errors.minlength">Phone Number must be at least 7 digit long</div>
                                 <div *ngIf="passportForm.controls.phone.errors.maxlength">Phone Number must be at most 13 digit long</div>
                                 <div *ngIf="passportForm.controls.phone.errors.pattern">Phone Number must be numbers only</div>
                 
                             </div>
                              <div class="help-block with-errors"></div>
                           </div>
                        </div>
                        <div class="col-lg-6">
                          <div class="form-group">
                            <label for="exampleInputEmail1">Gender</label>  
                              <select class="form-control select_input" name="gender" formControlName="gender" [ngClass]="{ 'is-invalid': submitted &amp;&amp; passportForm.controls.gender.errors }"
                              [style.border-color]="submitted &amp;&amp; passportForm.controls.gender.errors ?'#dc3545' : ''">
                                    <option value="">Select Gender</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                              </select>
                             
                             <div *ngIf="submitted &amp;&amp; passportForm.controls.gender.errors" class="form-text text-danger">
                                <div *ngIf="passportForm.controls.gender.errors.required">Address is required</div>
                             </div>
                             <div class="help-block with-errors"></div>
                          </div>
                       </div>

                     <div class="col-lg-6">
                        <div class="form-group">
                           <label for="exampleInputEmail1">Date Of Birth</label>  
                           <input type="date" title=" Date Of Birth" max="{{ date | date: 'yyyy-MM-dd' }}" class="percent_100 login_input_padding" name="dob" placeholder="Date of Birth"
                              formControlName="dob" [ngClass]="{ 'is-invalid': submitted &amp;&amp; passportForm.controls.dob.errors }"
                              [style.border-color]="submitted &amp;&amp; passportForm.controls.dob.errors ?'#dc3545' : ''" />
                     
                           <div *ngIf="submitted &amp;&amp; passportForm.controls.dob.errors" class="form-text text-danger">
                              <div *ngIf="passportForm.controls.dob.errors.required">Date of Birth is required</div>
                     
                           </div>
                           <div class="help-block with-errors"></div>
                        </div>
                     </div>

                     <div class="col-lg-6">
                        <div class="form-group">
                           <label for="exampleInputEmail1">Vaccine Name</label>  
                           <input type="text" class="percent_100 login_input_padding" name="vaccineName"
                              placeholder="Vaccine Name" formControlName="vaccineName"
                              [ngClass]="{ 'is-invalid': submitted &amp;&amp; passportForm.controls.vaccineName.errors }"
                              [style.border-color]="submitted &amp;&amp; passportForm.controls.vaccineName.errors ?'#dc3545' : ''" />
                     
                           <div *ngIf="submitted &amp;&amp; passportForm.controls.vaccineName.errors" class="form-text text-danger">
                              <div *ngIf="passportForm.controls.vaccineName.errors.required">Vaccine name is required</div>
                              <div *ngIf="passportForm.controls.vaccineName.errors.maxlength">Vaccine name cannot be more than
                                 45
                                 characters</div>
                              <!-- <div *ngIf="passportForm.controls.vaccineName.errors.pattern">Vaccine name must contain alphabets -->
                              <!-- </div> -->
                           </div>
                           <!-- <div class="help-block with-errors"></div> -->
                        </div>
                     </div>

                     <div class="col-lg-6">
                        <div class="form-group">
                           <label for="exampleInputEmail1">Vaccination Place</label>  
                           <input type="text" class="percent_100 login_input_padding" name="vaccinationPlace" placeholder="Vaccination Place"
                              formControlName="vaccinationPlace" [ngClass]="{ 'is-invalid': submitted &amp;&amp; passportForm.controls.vaccinationPlace.errors }"
                              [style.border-color]="submitted &amp;&amp; passportForm.controls.vaccinationPlace.errors ?'#dc3545' : ''" />
                     
                           <div *ngIf="submitted &amp;&amp; passportForm.controls.vaccinationPlace.errors" class="form-text text-danger">
                              <div *ngIf="passportForm.controls.vaccinationPlace.errors.required">Vaccination Place is required</div>
                              <div *ngIf="passportForm.controls.vaccinationPlace.errors.maxlength">Vaccination Place cannot be more than 45 characters</div>
                              <!-- <div *ngIf="passportForm.controls.vaccinationPlace.errors.pattern">Name must contain alphabets</div> -->
                           </div>
                           <!-- <div class="help-block with-errors"></div> -->
                        </div>
                     </div>

                     <div class="col-lg-6">
                        <div class="form-group">
                           <label for="exampleInputEmail1">Vaccination Country</label>  
                           <input type="text" class="percent_100 login_input_padding" name="vaccinationCountry" placeholder="Vaccination Country"
                              formControlName="vaccinationCountry"
                              [ngClass]="{ 'is-invalid': submitted &amp;&amp; passportForm.controls.vaccinationCountry.errors }"
                              [style.border-color]="submitted &amp;&amp; passportForm.controls.vaccinationCountry.errors ?'#dc3545' : ''" />
                     
                           <div *ngIf="submitted &amp;&amp; passportForm.controls.vaccinationCountry.errors" class="form-text text-danger">
                              <div *ngIf="passportForm.controls.vaccinationCountry.errors.required">Vaccination Country is required</div>
                              <div *ngIf="passportForm.controls.vaccinationCountry.errors.maxlength">Vaccination country cannot be more than 45
                                 characters</div>
                              <div *ngIf="passportForm.controls.vaccinationCountry.errors.pattern">Vaccination Country must contain alphabets</div>
                           </div>
                           <!-- <div class="help-block with-errors"></div> -->
                        </div>
                     </div>

                       <div class="col-lg-6">
                        <div class="form-group">
                           <label for="exampleInputEmail1">First Vaccination Date</label> 
                           <input type="date" title="First Vaccination Date" max="{{ date | date: 'yyyy-MM-dd' }}" class="percent_100 login_input_padding" name="f_date" placeholder="First Vaccination Date" formControlName="f_date"
                           [ngClass]="{ 'is-invalid': submitted &amp;&amp; passportForm.controls.f_date.errors }" 
                           [style.border-color]="submitted &amp;&amp; passportForm.controls.f_date.errors ?'#dc3545' : ''" />
                           
                           <div *ngIf="submitted &amp;&amp; passportForm.controls.f_date.errors" class="form-text text-danger">
                              <div *ngIf="passportForm.controls.f_date.errors.required">First Vaccination Date is required</div>
              
                          </div>
                           <div class="help-block with-errors"></div>
                        </div>
                     </div>
                     <div class="col-lg-6">
                        <div class="form-group">
                           <label for="exampleInputEmail1">First Dose Certificate</label> 
                            <input type="file" title="First Dose Certificate" class="percent_100 login_input_padding" name="f_dose_certificate" (change)="onFileChange($event, 1)" placeholder="First Dose Certificate" formControlName="f_dose_certificate"
                            [ngClass]="{ 'is-invalid': submitted &amp;&amp; passportForm.controls.f_dose_certificate.errors }" 
                            [style.border-color]="submitted &amp;&amp; passportForm.controls.f_dose_certificate.errors ?'#dc3545' : ''" />
                            
                            <div *ngIf="submitted &amp;&amp; passportForm.controls.f_dose_certificate.errors" class="form-text text-danger">
                               <div *ngIf="passportForm.controls.f_dose_certificate.errors.required">First Vaccination Certificate is required</div>
               
                           </div>
                            <div class="help-block with-errors"></div>
                         </div>
                     </div>

                     <div class="col-lg-6">
                        <div class="form-group">
                           <label for="exampleInputEmail1">Second Vaccination Date</label> 
                           <input type="date" title="Second Vaccination Date" max="{{ date | date: 'yyyy-MM-dd' }}" class="percent_100 login_input_padding" name="s_date" placeholder="Second Vaccination Date" formControlName="s_date"
                           [ngClass]="{ 'is-invalid': submitted &amp;&amp; passportForm.controls.s_date.errors }" 
                           [style.border-color]="submitted &amp;&amp; passportForm.controls.s_date.errors ?'#dc3545' : ''" />
                           
                           <div *ngIf="submitted &amp;&amp; passportForm.controls.s_date.errors" class="form-text text-danger">
                              <div *ngIf="passportForm.controls.s_date.errors.required">First Vaccination Date is required</div>
              
                          </div>
                           <div class="help-block with-errors"></div>
                        </div>
                     </div>
                     <div class="col-lg-6">
                        <div class="form-group">
                           <label for="exampleInputEmail1">Second Dose Certificate</label> 
                            <input type="file" title="Second Dose Certificate" class="percent_100 login_input_padding" name="s_dose_certificate" placeholder="Second Dose Certificate"
                             (change)="onFileChange($event, 2)" formControlName="s_dose_certificate"
                            [ngClass]="{ 'is-invalid': submitted &amp;&amp; passportForm.controls.s_dose_certificate.errors }" 
                            [style.border-color]="submitted &amp;&amp; passportForm.controls.s_dose_certificate.errors ?'#dc3545' : ''" />
                            
                            <div *ngIf="submitted &amp;&amp; passportForm.controls.s_dose_certificate.errors" class="form-text text-danger">
                               <div *ngIf="passportForm.controls.s_dose_certificate.errors.required">Second Vaccination Certificate is required</div>
               
                           </div>
                            <div class="help-block with-errors"></div>
                         </div>
                     </div>

                     <div class="col-lg-6">
                        <div class="form-group">

                           <label for="exampleInputEmail1">Are you recover from COVID-19 ?</label> 
                            <select class="form-control select_input" (change)="checkRecovery($event)" name="is_recover" 
                            formControlName="is_recover" [ngClass]="{ 'is-invalid': submitted &amp;&amp; passportForm.controls.is_recover.errors }"
                            [style.border-color]="submitted &amp;&amp; passportForm.controls.is_recover.errors ?'#dc3545' : ''">
                                  <option value="">Are you recover from COVID-19 ?</option>
                                  <option value="1">Yes</option>
                                  <option value="0">No</option>
                            </select>
                           
                           <div *ngIf="submitted &amp;&amp; passportForm.controls.is_recover.errors" class="form-text text-danger">
                              <div *ngIf="passportForm.controls.is_recover.errors.required">Recover from COVID-19 is required</div>
                           </div>
                           <div class="help-block with-errors"></div>
                        </div>
                     </div>

                     <div class="col-lg-6">
                        <div class="form-group">
                        <label for="exampleInputEmail1">Recover Certificate</label> 
                            <input type="file" title="Recovery Certificate" (change)="onFileChange($event, 3)" class="percent_100 login_input_padding" name="recover_certificate" placeholder="Recover Certificate" formControlName="recover_certificate"
                            [ngClass]="{ 'is-invalid': submitted &amp;&amp; isRecovered }" 
                            [style.border-color]="submitted &amp;&amp; isRecovered ?'#dc3545' : ''" />
                            
                            <div   class="form-text text-danger">
                               <div *ngIf="submitted &amp;&amp; isRecovered ">Recover Certificate is required</div>
               
                           </div>
                            <div class="help-block with-errors"></div>
                         </div>
                     </div>
                        
                    
                        <div class="col-lg-12">
                           <div class="text-center">
                              <button class="theme_btn tp_two logo-button-website" type="submit">Submit</button>
                           </div>
                        </div>
                     </div>
                  </div>
               </form>
            </div>
         </div>
         
       
      </div>
   </section>


 <app-footer></app-footer>
   
 </main>

<app-scrolltotop></app-scrolltotop>
<app-whatsupchat></app-whatsupchat>

 